export default "__VITE_ASSET__xEhmN5bB__"